'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { cn } from '../../utils/cn';
import { Tooltip, TooltipContent, TooltipPortal, TooltipTrigger } from '../Tooltip';
import { styles } from './ColorPicker.styles';
export const ColorPicker = ({ className, active, color, name, bg = 'var(--color-bg-modal)', ...props }) => {
    const style = useMemo(() => ({ backgroundColor: color, '--color-bg': bg }), [color, bg]);
    return (_jsxs(Tooltip, { children: [_jsx(TooltipTrigger, { asChild: true, children: _jsx("button", { type: "button", style: style, className: cn(styles.root, className), "data-state": active ? 'on' : 'off', "data-testid": "color-picker", ...props }) }), _jsx(TooltipPortal, { children: _jsx(TooltipContent, { side: "bottom", children: name ?? color }) })] }));
};
